import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const UserReviewIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "UserReviewIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.67467 22.0002H4.65855C3.45515 22.0002 2.47656 21.0217 2.47656 19.8188V13.1979C2.47656 11.995 3.45515 11.0164 4.65855 11.0164H7.67467C7.95371 11.0164 8.17949 11.2422 8.17949 11.5212V21.4954C8.17949 21.7745 7.95371 22.0002 7.67467 22.0002ZM4.65855 12.026C4.01223 12.026 3.48621 12.5515 3.48621 13.1979V19.8187C3.48621 20.4651 4.01224 20.9906 4.65855 20.9906H7.16985V12.026L4.65855 12.026Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9718 22.0002H7.67467C7.39563 22.0002 7.16985 21.7745 7.16985 21.4954C7.16985 21.2164 7.39563 20.9906 7.67467 20.9906H17.9718C18.7823 20.9906 19.4671 20.3837 19.5637 19.5792L20.5023 11.8017C20.5576 11.3467 20.4146 10.8892 20.1104 10.5461C19.8062 10.2029 19.3689 10.0062 18.9105 10.0062H14.1541C13.875 10.0062 13.6492 9.78044 13.6492 9.50141V5.23406C13.6492 4.63262 13.3175 4.08737 12.784 3.81079L11.6206 3.20737L8.14204 11.7125C8.03654 11.9713 7.74025 12.0936 7.4834 11.9886C7.22557 11.8831 7.10183 11.5883 7.20732 11.3299L10.8949 2.31357C10.9486 2.18244 11.0551 2.07989 11.1882 2.03108C11.3214 1.98277 11.4692 1.99115 11.5945 2.05672L13.2484 2.91453C14.1186 3.36562 14.6589 4.25399 14.6589 5.23405V8.99657H18.9105C19.6574 8.99657 20.3702 9.31701 20.8657 9.87607C21.3611 10.4351 21.5943 11.181 21.5051 11.923L20.5664 19.7004C20.4082 21.0113 19.293 22.0002 17.9718 22.0002Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default UserReviewIcon;
